<template>
  <v-dialog :model-value="modelValue" @update:model-value="$emit('update:modelValue', $event)" max-width="600px" persistent>
    <v-card>
      <v-card-title class="text-h5">{{ isUpdate ? 'Update' : 'Add' }} Billing Address</v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <v-text-field
              v-model="form.street_1"
              label="Street Address *"
              hide-details
              dense
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-text-field
              v-model="form.street_2"
              label="Street Address Line 2"
              hide-details
              dense
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model="form.city"
              label="City *"
              hide-details
              dense
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model="form.state"
              label="State / Province *"
              hide-details
              dense
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model="form.country"
              label="Country *"
              hide-details
              dense
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model="form.postal_code"
              label="Postal Code *"
              hide-details
              dense
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model="form.billing_email"
              label="Billing Email"
              hide-details
              dense
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model="form.vat_number"
              label="VAT Number"
              hide-details
              dense
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="handleCancel" data-testid="cancel-button">Cancel</v-btn>
        <v-btn color="primary" text @click="handleSave" :disabled="!isFormValid" data-testid="save-button">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { ref, computed, watch } from 'vue';

export default {
  name: 'BillingAddressModal',
  props: {
    modelValue: {
      type: Boolean,
      required: true,
    },
    initialAddress: {
      type: Object,
      default: null,
    },
  },
  emits: ['update:modelValue', 'save', 'cancel'],
  setup(props, { emit }) {
    const emptyForm = () => ({
      street_1: '',
      street_2: '',
      city: '',
      state: '',
      country: '',
      postal_code: '',
      billing_email: '',
      vat_number: '',
    });

    const form = ref(emptyForm());

    const isUpdate = computed(() => !!props.initialAddress);

    watch(
      () => props.modelValue,
      (open) => {
        if (open) {
          form.value = props.initialAddress
            ? { ...emptyForm(), ...props.initialAddress }
            : emptyForm();
        }
      },
      { immediate: true }
    );

    const isFormValid = computed(() =>
      !!(form.value.street_1 && form.value.city && form.value.state && form.value.country && form.value.postal_code)
    );

    const handleCancel = () => {
      emit('cancel');
    };

    const handleSave = () => {
      emit('save', { ...form.value });
    };

    return {
      form,
      isUpdate,
      isFormValid,
      handleCancel,
      handleSave,
    };
  },
};
</script>
